import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import type { CSSProperties } from 'react'

const infoContentStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  rowGap: '16px'
}

const TestConfigParameterNameInfo = () =>
  <div style={infoContentStyle}>
    <Paragraph>
      <Color variant='theme-description-text'>
        Parameter names are displayed alongside scope icons, which can be Global, State, or Action. Hover over the icons to view their respective scope names.
      </Color>
    </Paragraph>
    <Paragraph>
      <Color variant='theme-description-text'>
        All global parameters will be initialized in first test case action.
      </Color>
    </Paragraph>
    <Paragraph>
      <LinkToDocusaurus path='dai-test-configuration'>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </Paragraph>
  </div>

export default TestConfigParameterNameInfo
